/* eslint-disable
    func-names,
    no-shadow,
    no-underscore-dangle,
    no-unused-vars,
    no-use-before-define,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = [];

module.exports = angular
  .module('data.service.messageParser', deps)

  .factory('MessageParser', () => {
    let MessageParser;
    const escapeRegExp = str => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

    return (MessageParser = (function () {
      MessageParser = class MessageParser {
        static initClass() {
          this.prototype.choice = '';
          this.prototype.params = [];
          this.prototype.description = '';
        }
        constructor(params) {
          _.assignIn(this, params);
        }
        startsWith(str) {
          return this.choice.match(new RegExp(`^${escapeRegExp(str)}`, 'i')) != null;
        }
        isAtStartOf(str) {
          return str.match(new RegExp(`^${escapeRegExp(this.choice)}`, 'i')) != null;
        }
        serialize(str) {
          return str
            .trim()
            .split(' ')
            .slice(1, this.params.length + 1);
        }
        getMessage(str) {
          return __guard__(str.replace(this.choice, ''), x => x.trim());
        }
        getAssets(str) {
          return [];
        }

        static parse(message, parsers) {
          return parsers.reduce(
            (acc, parser) => ({
              message: parser.getMessage(acc.message),
              assets: acc.assets.concat(parser.getAssets(acc.message)),
            }),

            { message, assets: [] },
          );
        }
      };
      MessageParser.initClass();
      return MessageParser;
    })());
  });

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
